'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['perspective: 80px;'], ['perspective: 80px;']);

var _Box = require('../Box/Box');

var _Box2 = _interopRequireDefault(_Box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BoxThreeDXY = _Box2.default.extend(_templateObject);

exports.default = BoxThreeDXY;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-animated-burgers/lib/components/HamburgerThreeDXY/BoxThreeDXY.js
// module id = 119
// module chunks = 1